import { styled, theme } from "../../../../../../styles/stitches.config"

export const SCard = styled("div", {
  boxShadow: "3px 3px 24px #00000029",
  backgroundColor: theme.colors.white,
  transition: "all .3s ease-in-out",
  position: "relative",

  variants: {
    selected: {
      true: {
        borderColor: theme.colors.secondary,
      },
      false: {
        borderColor: theme.colors.white,
      },
    },
    vertical: {
      true: {
        width: theme.sizes.s75,
        paddingTop: theme.space.s4,
        paddingBottom: theme.space.s6,
        paddingLeft: theme.space.s6,
        paddingRight: theme.space.s6,
      },
      false: {
        width: "100%",
        height: "auto",
        paddingLeft: theme.space.s4,
        paddingRight: theme.space.s4,
      },
    },
  },
})
